/* PUSHAS 2026 - collection filters, plus small header and cart corrections.

   Filter chips: every facet renders as a wrapping row of content-sized chips. Earlier this file
   applied a fixed 54px chip grid to the whole sidebar, which was right for the size list but cut
   text labels off and overlapped them in Brand and Availability - the grid is now scoped to the
   size list alone, and every other facet wraps to fit its label.

   Size facet: it mixes apparel sizes, adult footwear, youth sizes and a tail of data errors in one
   50+ row list. This groups them, lays them out as a uniform chip grid, swaps the long
   "US M 8 / W 9-9.5" label for a Men's/Women's toggle, and hides values that are conditions rather
   than sizes. Purely presentational: the theme's own inputs, names and values are untouched, so
   filtering and the back button behave exactly as before.

   Header search: shortens the placeholder and pads the field so the caret starts inside the pill.

   Cart: adds a Shipping row under Subtotal reading "Determined at checkout". */
(function () {
  'use strict';
  var STORE = 'p26f-gender';
  var CSS =
    /* header search field */
    '.header__search-full .field .search__input,.search-modal__form .field .search__input,.header__search-input .field .search__input{padding-left:18px!important;padding-right:10px!important}' +

    /* ---- every facet: a wrapping row of chips that size to their label ---- */
    '.facets .facets__list{display:flex!important;flex-wrap:wrap!important;gap:8px!important;padding:0!important;margin:0!important;max-height:none!important;overflow:visible!important;list-style:none!important}' +
    '.facets .facets__item{display:block!important;margin:0!important;padding:0!important;border:0!important;width:auto!important;float:none!important;opacity:1!important;visibility:visible!important;height:auto!important}' +
    '.facets .facets__item input{position:absolute!important;opacity:0!important;width:0;height:0;pointer-events:none}' +
    '.facets .facets__item label.facet-checkbox{display:inline-flex!important;align-items:center;justify-content:center;gap:7px;min-height:36px;padding:0 14px!important;margin:0!important;border:1px solid #e6e6e6;border-radius:10px;background:#fff;font-size:12.5px;font-weight:600;line-height:1.2;color:#111;cursor:pointer;white-space:nowrap;transition:border-color .16s,background .16s,color .16s,transform .16s}' +
    /* the theme gives the inner span its own bordered box - flatten it */
    '.facets .facets__item label.facet-checkbox .text{display:inline!important;width:auto!important;min-width:0!important;padding:0!important;margin:0!important;border:0!important;background:none!important;font:inherit!important;color:inherit!important;text-transform:none!important;line-height:inherit!important}' +
    '.facets .facets__item label.facet-checkbox .count{font-weight:500;font-size:11.5px;color:#a0a0a0;font-variant-numeric:tabular-nums}' +
    '.facets .facets__item label.facet-checkbox::before,.facets .facets__item label.facet-checkbox::after{display:none!important}' +
    '.facets .facets__item label.facet-checkbox:hover{border-color:#111;transform:translateY(-1px)}' +
    '.facets .facets__item input:focus-visible+label.facet-checkbox{outline:2px solid #111;outline-offset:2px}' +
    '.facets .facets__item input:checked+label.facet-checkbox{background:#111;border-color:#111;color:#fff}' +
    '.facets .facets__item input:checked+label.facet-checkbox .count{color:rgba(255,255,255,.55)}' +
    '.facets [data-p26g="junk"]{display:none!important}' +
    '.facets .facets__show-more,.facets [class*="show-more"]{display:none!important}' +

    /* ---- size list only: a uniform grid, because the labels are all short numbers ---- */
    '.facets ul[data-p26f]{display:grid!important;grid-template-columns:repeat(auto-fill,minmax(58px,1fr))!important;gap:6px!important}' +
    '.facets ul[data-p26f] label.facet-checkbox{width:100%!important;padding:0 6px!important;font-variant-numeric:tabular-nums}' +
    '.facets ul[data-p26f] [data-p26g="other"]{grid-column:1/-1}' +
    '.facets ul[data-p26f] [data-p26g="other"] label.facet-checkbox{justify-content:flex-start;padding:0 14px!important;font-weight:500;color:#555}' +
    '.facets ul[data-p26f] .p26f-head{grid-column:1/-1;list-style:none;font-size:10.5px;font-weight:700;letter-spacing:.14em;text-transform:uppercase;color:#a0a0a0;margin:16px 0 2px}' +
    '.facets ul[data-p26f] .p26f-head.is-first{margin-top:0}' +
    '.facets ul[data-p26f] .p26f-gender{grid-column:1/-1;list-style:none;display:flex;padding:3px;border-radius:999px;background:#f2f2f2;margin:0 0 6px}' +
    '.facets ul[data-p26f] .p26f-gender button{flex:1;height:30px;border:0;border-radius:999px;background:transparent;font:inherit;font-size:11.5px;font-weight:700;color:#777;cursor:pointer;transition:background .16s,color .16s}' +
    '.facets ul[data-p26f] .p26f-gender button[aria-pressed="true"]{background:#111;color:#fff}' +

    /* ---- section headings and rhythm ---- */
    '.facets .sidebarBlock-heading{font-size:11px!important;font-weight:700!important;letter-spacing:.16em!important;text-transform:uppercase!important;color:#8a8a8a!important}' +
    '.facets .sidebarBlock+.sidebarBlock{border-top:1px solid #f0f0f0;margin-top:20px!important;padding-top:20px!important}' +

    /* ---- price: the two fields share the row; the max value used to clip at five figures ---- */
    '.facets .facets__price--box{display:flex!important;align-items:center!important;gap:8px!important;float:none!important}' +
    '.facets .facets__price--box .form-field{flex:1 1 0!important;min-width:0!important;width:auto!important;float:none!important;margin:0!important}' +
    '.facets .facets__price--box .field__currency{font-size:13px!important;color:#9a9a9a!important}' +
    '.facets .price-to-price{flex:0 0 auto!important;width:auto!important;padding:0!important;margin:0!important;font-size:12px!important;color:#9a9a9a!important}' +
    '.facets .filter__price{width:100%!important;height:44px!important;padding:0 8px 0 24px!important;font-size:12.5px!important;border:1px solid #e6e6e6!important;border-radius:10px!important;font-variant-numeric:tabular-nums}' +
    '.facets .filter__price:focus{border-color:#111!important;outline:none!important;box-shadow:none!important}' +
    '.facets .form-actions{margin-top:14px!important}' +
    '.facets .filter__price--apply{width:100%!important;height:44px!important;padding:0!important;border:1px solid #111!important;border-radius:999px!important;background:#111!important;color:#fff!important;font-size:11.5px!important;font-weight:700!important;letter-spacing:.14em!important;text-transform:uppercase!important;cursor:pointer}' +
    '.facets .filter__price--apply:hover{background:#000!important}';

  function injectCss() {
    if (document.getElementById('p26f-style')) return;
    var s = document.createElement('style');
    s.id = 'p26f-style';
    s.textContent = CSS;
    (document.head || document.documentElement).appendChild(s);
  }

  /* pushas-2026.js sets a longer hint; one word is all that fits the pill */
  function searchPlaceholder() {
    var sel = '.header__search-full .search__input, .search-modal__form .search__input, .header__search-input .search__input';
    var inputs = document.querySelectorAll(sel);
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].getAttribute('placeholder') !== 'Search') inputs[i].setAttribute('placeholder', 'Search');
    }
  }

  /* "Air Jordan(560)" reads as one word; drop the brackets and let CSS mute the number */
  function tidyCounts() {
    var cs = document.querySelectorAll('.facets .facet-checkbox .count');
    for (var i = 0; i < cs.length; i++) {
      var m = (cs[i].textContent || '').trim().match(/^\(([\d,]+)\)$/);
      if (m) cs[i].textContent = m[1];
    }
  }

  /* Shipping line under Subtotal so the cost is flagged before checkout */
  function cartShipping() {
    var lists = document.querySelectorAll('.cart-totals');
    for (var i = 0; i < lists.length; i++) {
      var ul = lists[i];
      if (ul.querySelector('.p26-cart-ship')) continue;
      var sub = ul.querySelector('.cart-total-subtotal');
      if (!sub || !sub.parentNode) continue;
      var li = document.createElement('li');
      li.className = 'cart-total p26-cart-ship';
      li.innerHTML = '<div class="cart-total-label"><span class="text">Shipping</span></div>' +
                     '<div class="cart-total-value"><span class="text">Determined at checkout</span></div>';
      sub.parentNode.insertBefore(li, sub.nextSibling);
    }
  }

  var APPAREL = /^(one size|2xs|xs|s|m|l|xl|2xl|3xl|4xl)$/i;
  var JUNK = /damaged/i;
  var YOUTH = /^([\d.]+)\s*Y$/i;
  var FOOT = /^US\s*M(?:ens)?\.?\s*([\d.]+)/i;
  var WOMENS = /W\s*([\d.]+(?:\s*-\s*[\d.]+)?)/i;

  function head(text, first) {
    var e = document.createElement('li');
    e.className = 'p26f-head' + (first ? ' is-first' : '');
    e.textContent = text;
    return e;
  }

  function paint(ul, g) {
    var btns = ul.querySelectorAll('.p26f-gender button');
    for (var i = 0; i < btns.length; i++) {
      btns[i].setAttribute('aria-pressed', String(btns[i].getAttribute('data-g') === g));
    }
    var foot = ul.querySelectorAll('[data-p26g="foot"]');
    for (var j = 0; j < foot.length; j++) {
      var it = foot[j];
      var sp = it.querySelector('.text');
      if (!sp) continue;
      sp.textContent = g === 'w' ? it.getAttribute('data-w') : it.getAttribute('data-m');
      var lb = it.querySelector('label');
      if (lb) {
        lb.setAttribute('title', it.getAttribute('data-orig'));
        lb.setAttribute('aria-label', it.getAttribute('data-orig'));
      }
    }
  }

  function gender() {
    try { return localStorage.getItem(STORE) === 'w' ? 'w' : 'm'; } catch (e) { return 'm'; }
  }

  function enhance(ul) {
    if (!ul || ul.getAttribute('data-p26f')) return;
    var items = [].slice.call(ul.querySelectorAll('li'));
    if (items.length < 12) return;

    var foot = [], youth = [], apparel = [], other = [], junk = [], seen = {}, found = false;

    items.forEach(function (it) {
      var sp = it.querySelector('.text');
      if (!sp) return;
      var t = (it.getAttribute('data-orig') || sp.textContent).replace(/\s+/g, ' ').trim();
      it.setAttribute('data-orig', t);
      if (JUNK.test(t)) { it.setAttribute('data-p26g', 'junk'); junk.push(it); return; }
      var m = t.match(FOOT);
      if (m) {
        if (seen[m[1]]) { it.setAttribute('data-p26g', 'other'); other.push(it); return; }
        seen[m[1]] = 1;
        found = true;
        var w = t.match(WOMENS);
        it.setAttribute('data-p26g', 'foot');
        it.setAttribute('data-m', m[1]);
        it.setAttribute('data-w', w ? w[1].replace(/\s*-\s*/, '-') : m[1]);
        foot.push(it);
        return;
      }
      if (YOUTH.test(t)) { it.setAttribute('data-p26g', 'youth'); youth.push(it); return; }
      if (APPAREL.test(t)) { it.setAttribute('data-p26g', 'apparel'); apparel.push(it); return; }
      it.setAttribute('data-p26g', 'other');
      other.push(it);
    });

    if (!found) return;

    foot.sort(function (a, b) { return parseFloat(a.getAttribute('data-m')) - parseFloat(b.getAttribute('data-m')); });
    youth.sort(function (a, b) { return parseFloat(a.getAttribute('data-orig')) - parseFloat(b.getAttribute('data-orig')); });

    var g = gender();
    var frag = document.createDocumentFragment();

    frag.appendChild(head('Footwear (US)', true));
    var tog = document.createElement('li');
    tog.className = 'p26f-gender';
    tog.innerHTML = '<button type="button" data-g="m" aria-pressed="' + (g === 'm') + '">Men\'s</button>' +
                    '<button type="button" data-g="w" aria-pressed="' + (g === 'w') + '">Women\'s</button>';
    frag.appendChild(tog);
    foot.forEach(function (e) { frag.appendChild(e); });
    if (youth.length) { frag.appendChild(head('Youth')); youth.forEach(function (e) { frag.appendChild(e); }); }
    if (apparel.length) { frag.appendChild(head('Apparel')); apparel.forEach(function (e) { frag.appendChild(e); }); }
    if (other.length) { frag.appendChild(head('Other')); other.forEach(function (e) { frag.appendChild(e); }); }
    junk.forEach(function (e) { frag.appendChild(e); });

    ul.appendChild(frag);
    ul.setAttribute('data-p26f', '1');

    paint(ul, g);

    tog.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('button[data-g]') : null;
      if (!b) return;
      var ng = b.getAttribute('data-g');
      try { localStorage.setItem(STORE, ng); } catch (err) {}
      var all = document.querySelectorAll('ul[data-p26f]');
      for (var i = 0; i < all.length; i++) paint(all[i], ng);
    });
  }

  function run() {
    injectCss();
    searchPlaceholder();
    cartShipping();
    var uls = document.querySelectorAll('ul');
    for (var i = 0; i < uls.length; i++) {
      if (uls[i].querySelector('input[name="filter.v.option.size"]')) enhance(uls[i]);
    }
    tidyCounts();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();

  var t;
  new MutationObserver(function () {
    clearTimeout(t);
    t = setTimeout(run, 120);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
